import _ from 'lodash';
import {
  ParCommissionResponse,
  ParOfferResponse,
  PricingPackResponse,
} from '../../../services/pricing';
import { PropElementRequest } from '../../../services/proposal';
import moment from 'moment';
export function commissionToElement(
  offer: PricingPackResponse,
  pricing: any,
  commission: ParCommissionResponse,
  cteidparent: number,
  investamount: number,
  commpercentage?: number,
  data?: ParOfferResponse,
  assetParticipation?: boolean,
  partmethod?: string,
  partamount?: number
): PropElementRequest {
  // SERV = serviceduration ==> ctecalculationtype
  // SERV = servicecalculationmethod ==> ctecalculationbasis
  // FIN = calculationmethod ==>ctecalculationtype
  const cupfront =
    (((data?.upfrontdefault ?? 0) as number) * investamount) / 100;
  const cpart = assetParticipation
    ? partamount ?? 0
    : data?.partamount
    ? (data.partrate * investamount) / 100
    : 0;

  const part = isNaN(cpart) ? 0 : cpart;
  const upfront = isNaN(cupfront) ? 0 : cupfront;

  const finamount = investamount - upfront - part;
  return {
    conElemAttributes: [],
    offer: {
      ofrid: offer.ofrid,
      ofrtype: offer.ofrtype,
      ofrlabel: offer.ofrlabel,
      ofrdescription: '',
    },
    deferredinterestratetype: '',
    depositratetype: '',
    ofrid: offer.ofrid,
    ofrlabel: offer.ofrlabel,
    ofrtype: offer.ofrtype,
    taxrate: commission.taxrate,
    taxtype: commission.taxtype,
    assetid: 0,
    conElemAssets: [],
    conElemSchedules: pricing.conElemSchedules,
    conElemSteps: [],
    conElemServiceSteps: [],
    ctebilligdate: pricing.ctebilligdate ?? '05',
    cteactuarialrate: 0,
    ctecalculationbasis: commission.commbasis,
    ctecalculationtype: commission.commduration,
    ctecategory: commission.commcode,
    ctecategorylabel: commission.commlabel,
    ctedeferredinterest: 0,
    ctedeferredinterestmethod: '',
    ctedeferredinterestnominalrate: 0,
    ctedepositamount: 0,
    ctedepositcoef: 0,
    ctedepositinterest: 0,
    ctedepositinterestmethod: '',
    ctedepositnominalrate: 0,
    ctedescription: commission.commlabel,
    ctedirection: 'OUT',
    cteduration: commission.commdurationdefault,
    cteendamount: 0,
    cteenddate: '',
    ctefinancedamount: finamount ?? 0,
    ctefirstpayment: 0,
    ctefirstpaymentcoef: 0,
    ctefirstpaymentdate: '',
    ctefree1: '',
    ctegraceperiodduration: 0,
    ctegraceperiodmethod: '',
    cteid: Math.round(_.random(10000000)),
    cteidparent: cteidparent,
    cteinitialamount: 0,
    cteinstallmentamount:
      commission.commfixedamount !== pricing.cteinstallmentamount
        ? pricing.cteinstallmentamount
        : commission.commfixedamount,
    cteinterestmethod: '',
    cteinvestamount: investamount,
    ctenominalrate: commpercentage ?? commission.commpercentage,
    cteorder: 2,
    ctepartmethod: assetParticipation ? partmethod ?? '' : data?.partmethod ?? '',
    ctepartamount: assetParticipation
      ? part
      : data?.partmethod === 'FIXED'
      ? data.partamount ?? 0
      : ((data?.partrate ?? 0) * investamount) / 100,

    ctepartdays: 0,
    ctepartrate: 0,
    ctepaymentterm: pricing.term,
    cteperiodicity: commission.commperiodicity,
    ctemileage: 0,
    ctepriidexceed: 0,
    cteratebasis: '',
    cterateformula: '',
    cterateperiodicity: '',
    cteratespread: 0,
    cterateterm: '',
    cteratetype: '',
    rvcalculationmode: '',
    rvevaluationmode: '',
    prefinrateref: 0,
    prefinratespread: 0,
    cterateref: 0,
    cterentalamount: commission.commfixedamount,
    ctervamount: 0,
    ctervcoef: 0,
    ctestartamount: 0,
    ctestartdate: moment(),
    ctestatus: 'INIT',
    ctetype: 'COMM',
    cteunit: 'M',
    cteupfrontamount: upfront,
    ctrid: 0,
    currcode: pricing.currcode,
    last_action: '',
    prefinbasis: '',
    prefinmethod: '',
    prefinnominalrate: 0,
    prefinperiodicity: '',
    prefinrateformula: '',
    prefinratetype: '',
    priid: pricing.priid,
    taxcode: pricing.taxcode,
    tpid: commission.tpid,
    tpidparticipation: 0,
    calculatedamountbasis: '',
    marginoncalulatedcamount: 0,
    additionalcostaftermargin: 0,
    servfixedamount:
      commission?.commfixedamount ??
      pricing.commissionResponse?.commfixedamount,
    servpercentage:
      commission?.commpercentage ?? pricing.commissionResponse?.commpercentage,
    servbasis: 0,
    pritype: '',
    helpers: {
      servfixedamountmin: pricing.servfixedamountmin,
      servpercentagemin: pricing.servpercentagemin,
      servcontextmin: pricing.servcontextmin,
      durationmax: 0,
      durationmin: 0,
      marginratemin: 0,
      marginratemax: 0,
      margincontextmin: 0,
      margincontextmax: 0,
      //durationdefault: pricing.durationdefault ? pricing.durationdefault : 0,
      frmin: 0,
      frmax: 0,
      upmin: 0,
      upmax: 0,
      rvmax: 0,
      rvmin: 0,
      gpmax: 0,
      gpmin: 0,
      rvcontextmax: 0,
      rvcontextmin: 0,
      gpdurationmax: 0,
      ratemax: pricing.ratevaluedefault
        ? pricing.ratevaluedefault + pricing.ratespreadmax
        : 30,
      ratemin: pricing.ratevaluedefault
        ? pricing.ratevaluedefault + pricing.ratespreadmin
        : 1,
      ratecontextmax: 0,
      ratecontextmin: 0,
      frcontextmax: 0,
      frcontextmin: 0,
      durationcontextmax: 0,
      durationcontextmin: 0,
    },
    spvassetdiscount: 0,
    spvriskrate: 0,
    spvadditionalfees: 0,
    spvloancoef: 0,
    spvdiscountsale: 0,
    spvinflation: 0,
    spvassetdiscountamount: 0,
    spvloanamount: 0,
    spvriskamount: 0,
    spvfeesamount: 0,
    serviceResponse: pricing.serviceResponse,
    serviceStepList: pricing.serviceStepList,
    pricingStepList: pricing.pricingStepList,
    commissionResponse: commission,
    pricing: pricing,
    rvauthid: pricing.rvauthid,
    rvtaskid: pricing.rvtaskid,
    rateauthid: pricing.rateauthid,
    ratetaskid: pricing.ratetaskid,
    frauthid: pricing.frauthid,
    frtaskid: pricing.frtaskid,
    durationauthid: pricing.durationauthid,
    durationtaskid: pricing.durationtaskid,
    servtaskid: 0,
    servauthid: 0,
    margintaskid: 0,
    marginauthid: 0,
    ctefeesamount: 0,
    ctecommissionamount: 0,
    cteprofitabilityrate: 0,
    cteaprrate: 0,
    cteflatrate: 0,
    ctecoefrate: 0,
    ctefundingrate: 0,
    ctefundingperiodicity: 0,
    ctefundinginstallment: 0,
    ctefundingcost: 0,
    ctemarginamount: 0,
    ctemarginrate: 0,
    ctevatdeferralamount: 0,
    ctevatdeferralduration: 0,
    ctevatdeferralmethod: 'NONE',
    ctevatdeferraldaysbasis: '365',
    cteextracosttofinance: 0,
    cteextracostcomment: '',
    totalInterest: 0,
    totalRental: 0,
    totalAmortization: 0,
    totaldiscountedInterest: 0,
    totalVatDeffered: 0,
    totaldiscountedOutstanding: 0,
    totaldiscountedAgiosdeb: 0,
    totalAgiosdeb: 0,
    marginImpactCredit: 0,
    marginImpactDebit: 0,
    dgo: 0,
    profitabilityAmount: 0,
    ceilingrate: 0,
    ceilingdefaultrate: 0,
    floorrate: 0,
    floordefaultrate: 0,
    calid: 0,
    servusecoverage: 0,
    servusedeductionamount: 0,
    servusedeductionpercenrage: 0,
    servusefrequency: '',
    servusemaxamount: 0,
    servuseminamount: 0,
    servuseqty: 0,
    servuseunit: '',
    servdescription: '',
  };
}
